import { z } from "zod";

export const defaultRatesFormSchema = z.object({
  mode: z.enum(["default", "raise", "lower"]),
  raisePricing: z.coerce.number().int().nonnegative().max(1000),
  lowerPricing: z.coerce.number().int().nonnegative().max(99),
});

export type DefaultRatesFormData = z.infer<typeof defaultRatesFormSchema>;